import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

// Auto-dismissing "notification" announcing the 100% Halal fact.
// Slides in from the bottom corner (never overlaps the header), shows once per session.
export const HalalPopup = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("sc_halal_seen")) return;
    const showT = setTimeout(() => {
      sessionStorage.setItem("sc_halal_seen", "1");
      setShow(true);
    }, 1200);
    const hideT = setTimeout(() => setShow(false), 6200); // pops once, then goes away
    return () => { clearTimeout(showT); clearTimeout(hideT); };
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed bottom-4 left-4 right-4 z-[90] mx-auto w-auto max-w-sm sm:left-auto sm:right-6 sm:bottom-6 sm:mx-0"
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ type: "spring", damping: 24, stiffness: 260 }}
          data-testid="halal-popup"
        >
          <div className="glass relative flex items-center gap-3 rounded-2xl border border-gold/30 px-4 py-3 gold-glow overflow-hidden">
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-gold text-ink font-display font-bold text-sm">
              ﷺ
            </span>
            <div className="flex-1">
              <p className="text-[11px] uppercase tracking-[0.22em] text-gold font-semibold">Good to know</p>
              <p className="text-sm font-semibold text-cream leading-snug">
                All our menu is <span className="text-gold">100% Halal</span>.
              </p>
            </div>
            <button
              onClick={() => setShow(false)}
              aria-label="Dismiss"
              data-testid="halal-popup-close"
              className="h-8 w-8 grid place-items-center rounded-full text-cream/60 hover:text-cream hover:bg-white/10 transition-colors"
            >
              <X size={16} />
            </button>
            {/* auto-dismiss progress bar */}
            <motion.span
              className="absolute bottom-0 left-0 h-0.5 bg-gold/70"
              initial={{ width: "100%" }}
              animate={{ width: "0%" }}
              transition={{ duration: 5, ease: "linear" }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default HalalPopup;
